import { render, staticRenderFns } from "./ModalImportarSigtap.vue?vue&type=template&id=1b486c77&scoped=true"
import script from "./ModalImportarSigtap.vue?vue&type=script&lang=js"
export * from "./ModalImportarSigtap.vue?vue&type=script&lang=js"
import style0 from "./ModalImportarSigtap.vue?vue&type=style&index=0&id=1b486c77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b486c77",
  null
  
)

export default component.exports